import { Link } from 'react-router-dom';
import { RegisterFlow } from '../components/register-flow';
import { MENSAJE_REGISTRO_CERRADO, useRegistroPublico } from '../hooks/use-registro-publico';

export function RegisterPage() {
  const abierto = useRegistroPublico();

  // Mientras el servidor no responde no se muestra nada: ni el formulario ni el mensaje.
  if (abierto === null) return null;
  if (abierto) return <RegisterFlow />;

  // Cerrado (lo normal): no crea empresas. Explica cómo se prueba Prixia y ofrece entrar.
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-gray-50">
      <div className="w-full max-w-sm bg-white border border-gray-200 rounded-2xl p-7 shadow-sm text-center space-y-4">
        <img src="/prixia-logo.svg" alt="Prixia" className="h-10 w-auto mx-auto" />
        <h1 className="text-lg font-semibold text-gray-900">
          Prixia se prueba con una demo guiada
        </h1>
        <p className="text-sm text-gray-700">{MENSAJE_REGISTRO_CERRADO}</p>
        <p className="text-sm text-gray-700">
          Quien recibe la invitación entra a una copia de Prixia con datos de ejemplo y la recorre
          paso a paso. Si ya tienes una cuenta, inicia sesión.
        </p>
        <Link
          to="/login"
          className="inline-flex justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Iniciar sesión
        </Link>
      </div>
    </div>
  );
}

export default RegisterPage;
